<div class="container">
  <div class="header">
    <h3 class="header-title">Bestellmanager</h3>
    <button (click)="close()">
      <ui-icon faName="xmark" faStyle="light"></ui-icon>
      Schließen
    </button>
  </div>
  @if (nav()?.children; as items) {
    <mat-nav-list>
      @for (link of items; track link) {
        <a uiNavLink [link]="link">
          <mat-list-item mat-ripple>
            <ui-icon matListItemIcon [faStyle]="link.icon?.family!" [faName]="link.icon?.name!"></ui-icon>
            <span matListItemTitle>{{ link.label }}</span>
            <span matListItemLine>{{ link.description }}</span>
            <ui-icon matListItemMeta faName="chevron-right" faStyle="light"></ui-icon>
          </mat-list-item>
        </a>
      }
    </mat-nav-list>
  }
</div>
